import {startTypeShuffle, toggleModalSketch, utils} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function templateTrophyRoomInit() {

	gsapContext.add(() => {

		const trophyRoom      = document.querySelector('.trophy-room');
		const trophyRoomBtns  = trophyRoom.querySelectorAll('.trophy-room__menu .btn');
		const trophyRoomItems = trophyRoom.querySelectorAll('.trophy-room__item');

		const btnActiveClass                   = 'btn--bg-white';
		const btnInactiveClass                 = 'btn--bg-medium';
		const doorsOpeningAnimationDuration    = 2000;
		const doorsClosingAnimationDuration    = 1000;
		let productShowDelay                   = 0;
		let productShowAnticipation            = 1500;
		let productTransitionAnimationDuration = 1000;

		trophyRoomBtns.forEach((el) => {
			el.addEventListener('click', function () {
				// exit if button is already active
				if (this.classList.contains(btnActiveClass))
				{
					return false;
				}

				const id         = el.dataset.id;
				const activeItem = document.querySelector('.trophy-room__item[data-id="' + id + '"]');

				// make all buttons inactive
				trophyRoomBtns.forEach((el) => {
					if (!el.isEqualNode(this))
					{
						el.classList.remove(btnActiveClass);
						el.classList.add(btnInactiveClass);
					}
				});

				// make clicked buttons active
				this.classList.add(btnActiveClass);
				this.classList.remove(btnInactiveClass);

				// if the doors are already open, close the doors and open them again after the end of the closing animation
				if (trophyRoom.classList.contains('open'))
				{
					trophyRoom.classList.remove('open');

					setTimeout(function () {
						trophyRoom.classList.add('open');
					}, doorsClosingAnimationDuration);

					productShowDelay = doorsClosingAnimationDuration + doorsOpeningAnimationDuration - productShowAnticipation;
				}
				// if the doors are closed, open them
				else
				{
					trophyRoom.classList.add('open');

					productShowDelay = doorsOpeningAnimationDuration - productShowAnticipation;
				}

				// make all other items invisible
				trophyRoomItems.forEach((el) => {
					if (!el.isEqualNode(activeItem))
					{
						el.classList.remove('visible');

						// make all items inactive
						setTimeout(function () {
							el.classList.remove('active');
						}, productTransitionAnimationDuration);
					}
				});

				// make selected item active
				setTimeout(function () {
					activeItem.classList.add('active');
				}, productShowDelay);

				// make selected item visible
				setTimeout(function () {
					activeItem.classList.add('visible');
				}, productShowDelay + 50);

				// refresh gsap triggers after the change
				setTimeout(function () {
					ScrollTrigger.getAll().forEach(t => t.refresh());
				}, 500);
			});
		});

	});

}